module.exports = __webpack_public_path__ + "static/img/examine.83f0cac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/examine.png
// module id = 9eVA
// module chunks = 1